import React, { useEffect } from "react";
import SoulMachinesTable from "../components/soulMachinesTable";
const SoulMachines = ({ setLoader, loader }) => {
  return <SoulMachinesTable setLoader={setLoader} loader={loader} />;
};

export default SoulMachines;
